/**
 * GIS Module
 * Geographic Information System module
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import type { Module } from '../../../index';
import Layout from '../../../components/Layout';
import PrivateRoute from '../../../components/PrivateRoute';
import Dashboard from './Dashboard';
import DataStores from './DataStores';
import Layers from './layers/Layers';
import LayerGroups from './LayerGroups';
import BaseLayers from './BaseLayers';
import DataLayers from './DataLayers';
import ExternalApplications from './ExternalApplications';

const gisModule: Module = {
  name: 'gis',
  path: '/app/gis',
  routes: [
    {
      path: '/app/gis',
      element: <PrivateRoute><Layout /></PrivateRoute>,
      children: [
        {
          index: true,
          element: <Dashboard />
        },
        {
          path: 'dashboard',
          element: <Dashboard />
        },
        {
          path: 'stores',
          element: <DataStores />
        },
        {
          path: 'layers',
          element: <Layers />
        },
        {
          path: 'layer-groups',
          element: <LayerGroups />
        },
        {
          path: 'base-layers',
          element: <BaseLayers />
        },
        {
          path: 'data-layers',
          element: <DataLayers />
        },
        {
          path: 'external-applications',
          element: <ExternalApplications />
        }
      ]
    }
  ]
};

export default gisModule;

